// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3IPwr","info":"info__2tApI","price":"price__3ATkj","name":"name__2sWkB","border":"border__1fIg7"};